export const backgroundThemes = {
  DARK: 'Dark',
  GRAY: 'Gray',
  LIGHT: 'Light',
}

export const paddingSizes = {
  NONE: { name: 'None', size: 0 },
  SMALL: { name: 'Small', size: 64 },
  LARGE: { name: 'Large', size: 96 },
}

// flexible Hero types
export const useCases = {
  SMALL_KEY: 'Small Key Value',
  TALL_KEY: 'Tall Key Value',
  CENTER: 'Centered',
}

// Navbar section name
export const groupNameColor = (color: string) => {
  switch (color) {
    case 'Red':
      return '#FA4616'
    case 'Blue':
      return '#0BA2B3'
    case 'Orange':
      return '#FA4616'
    case 'Yellow':
      return '#F4A700'
    case 'Green':
      return '#0BA2B3'
    case 'Purple':
      return 'purple'
    case 'Pink':
      return '#ED145B'
    case 'Dark blue':
      return '#0079BF'
    default:
      return '#4F5F66'
  }
}
